import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3 article-block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-5 bg-white" }
const _hoisted_4 = { class: "card-img-wrap" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "version-intro-card" }
const _hoisted_8 = { class: "chronicle-title" }
const _hoisted_9 = { class: "year-title" }
const _hoisted_10 = { class: "rocknuts-title" }
const _hoisted_11 = { class: "auther-title" }
const _hoisted_12 = { class: "publish-time" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "rank-item-list is_short" }
const _hoisted_15 = { class: "read-more" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "media" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "media-body" }
const _hoisted_20 = { class: "mt-0" }
const _hoisted_21 = { class: "auther-title" }
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.full==2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RouterLink, { to: _ctx.link_to }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "card-img",
                    src: _ctx.primary_img,
                    alt: "artist image"
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.full==2 || _ctx.full==1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: _ctx.link_to }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.article.main_chronicle_id.title), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_RouterLink, { to: _ctx.link_to }, {
                default: _withCtx(() => [
                  _createTextVNode(" [ " + _toDisplayString(_ctx.article.begin_year) + " - " + _toDisplayString(_ctx.article.end_year) + "] " + _toDisplayString(_ctx.article.title), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(" BY "),
                _createVNode(_component_UserTag, {
                  user: _ctx.article.user_created,
                  full: 1
                }, null, 8, ["user"]),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
                  (_ctx.article.ts_updated!=_ctx.article.ts_published)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" ] ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.styles, (style) => {
                return (_openBlock(), _createBlock(_component_StyleTag, {
                  key: style._id,
                  genre: style,
                  full: 0
                }, null, 8, ["genre"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_RouterLink, { to: _ctx.link_to }, {
                default: _withCtx(() => [
                  _createTextVNode(" Read More ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.full==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: _ctx.primary_img,
              class: "align-self-start mr-3 img-fluid",
              style: {"width":"100px"}
            }, null, 8, _hoisted_18),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h5", _hoisted_20, [
                _createVNode(_component_RouterLink, { to: _ctx.link_to }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_UserTag, {
                  user: _ctx.article.user_created,
                  full: 1
                }, null, 8, ["user"]),
                _createTextVNode(" [ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_updated)) + " ", 1),
                (_ctx.article.ts_updated!=_ctx.article.ts_published)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "/ " + _toDisplayString(_ctx.formatTS(_ctx.article.ts_published)), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" ] ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}